export default __webpack_public_path__ + "static/media/dashboards.9d81d26c.svg";